<template>
  <div class="pa-5">
    <v-select
      v-model="selectedMedia"
      :items="items"
      item-text="label"
      item-value="deviceId"
      @input="changeMicro"
    ></v-select>
  </div>
</template>

<script>
import { twilioMixin } from '@/mixins/twilioMixin.js'
import { mapState } from 'vuex'

export default {
  name: 'ModalSelectMicro',

  mixins: [twilioMixin],

  data() {
    return {
      selectedMedia: null,
      items: []
    }
  },

  computed: {
    ...mapState({
      roomDevicesAudio: (state) => state.roomDevices.audio
    })
  },

  async mounted() {
    this.items = await this.getInputDevices('audio')
    const local = localStorage.getItem('audioDeviceId') || this.roomDevicesAudio
    const deviceId = this.items.find((el) => el.deviceId === local)
    if (deviceId) this.selectedMedia = deviceId
  },

  methods: {
    changeMicro(deviceId) {
      this.saveNewDevice('audio', deviceId)
    }
  }
}
</script>
